import { render } from "./CompanyInfoPageTitle.vue?vue&type=template&id=9ef91238&scoped=true"
import script from "./CompanyInfoPageTitle.vue?vue&type=script&lang=js"
export * from "./CompanyInfoPageTitle.vue?vue&type=script&lang=js"

import "./CompanyInfoPageTitle.vue?vue&type=style&index=0&id=9ef91238&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ef91238"]])

export default __exports__